import type { ProductsDict } from '@/routes/app/products/products.types';

import { ProductProfileUserCombobox } from '../product-profile-user-combobox';

export type ProductFormProfileUserFieldProps = {
  workspaceId?: string;
  value: string | null;
  onChange: (v: string | null) => void;
  dict: ProductsDict | undefined;
  required?: boolean;
  allowNone?: boolean;
};

export function ProductFormProfileUserField({
  workspaceId,
  value,
  onChange,
  dict,
  required,
  allowNone,
}: ProductFormProfileUserFieldProps) {
  const label =
    dict?.setup?.profileUser ??
    dict?.edit?.routing?.routingProfile ??
    'Profile (user)';

  return (
    <ProductProfileUserCombobox
      workspaceId={workspaceId}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={dict?.setup?.profileNone ?? 'Select team member…'}
      searchPlaceholder={
        dict?.setup?.profileSearchPlaceholder ?? 'Search by name or email…'
      }
      emptyMessage={dict?.setup?.profileSearchEmpty ?? 'No members found'}
      loadErrorMessage={
        dict?.setup?.profileSearchError ?? 'Could not load members.'
      }
      noneLabel={dict?.setup?.profileNone}
      allowNone={allowNone}
      required={required}
    />
  );
}
